import React, { useState, useEffect} from "react";
import { useNavigate } from "react-router";

import { useGetHabitsQuery } from "@/features/habits/habitsApiSlice";
import { useGetUserHabitLogsQuery, useCreateNewUserHabitLogMutation } from '@/features/userHabitLogs/userHabitLogsApiSlice' // 29 Jun 2025

import EtEnergyPhysicalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyPhysicalIcon1SVGComp"
import EtEnergyMentalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyMentalIcon1SVGComp"
import EtEnergyEmotionalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyEmotionalIcon1SVGComp"
import EtEnergyIntellectualIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyIntellectualIcon1SVGComp"
import EtEnergySpiritualIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergySpiritualIcon1SVGComp"

import EtHabitsAffirmIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsAffirmIcon1SVGComp"
import EtHabitsDietIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsDietIcon1SVGComp"
import EtHabitsExerciseIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsExerciseIcon1SVGComp"
import EtHabitsGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsGratitudeIcon1SVGComp"
import EtHabitsMeditateIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsMeditateIcon1SVGComp"
import EtHabitsReadIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsReadIcon1SVGComp"
import EtHabitsSleepIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsSleepIcon1SVGComp"
import EtHabitsSortIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsSortIcon1SVGComp"
import EtHabitsWriteIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsWriteIcon1SVGComp"

import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon,
  CheckCircleIcon, 
} from "@heroicons/react/24/solid"

// 02 Jul 2025
import EtHabitPerformanceDetailMobile from "@/components/habits/EtHabitPerformanceDetailMobile"

import { createSvgComponentFromBase64 } from '@/utils/createSvgComponentFromBase64' 

// 06 Dec 2025
import {
  ComposedChart,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Scatter,
  Cell,
  Legend,
} from "recharts";


import moment from 'moment' // 29 Jun 2025

// 23 Feb 2026
import EtLogoutIcon1SVGComp from "@/assets/img/icons/svgComp/EtLogoutIcon1SVGComp" 
import TrinityIcon from '@/assets/img/icons/base64Svgs/trinityRoundIcon1.svg'
import { useSendLogoutMutation } from "@/features/auth/authApiSlice"


const EtTrinityMorningHabitsMobile = ({ userId, onClose }) => {
  
  // First Created - 20 Feb 2026
  // Author - Atul Pandey
  // Inherited from EtTrinityMorningHabits.jsx comp and refined the display JSX for mobile.
  // Updated - 23 Feb 2026 - JSX refinements - header
  // Updated - 24 Feb 2026 - JSX refinements - log display cards

  const navigate = useNavigate();

  const handleClose = () => {
    // 1) prefer parent-provided close (modal etc.)
    if (typeof onClose === "function") {
      onClose();
      return;
    }

    // 2) fallback: go to your mobile home route
    navigate("/etapp/mobile"); // <-- change this to your actual mobile home route if different
  };

  // 1a - State Variables
  const [selectedHabitIds, setSelectedHabitIds] = useState([]);
  const [performanceByHabitId, setPerformanceByHabitId] = useState({}); // 27 Jun 2025

  // 29 Jun 2025 - New state additions
  const [performedToggle, setPerformedToggle] = useState({});
  const [timePicker, setTimePicker] = useState({});
  const [experienceNotes, setExperienceNotes] = useState({});
  const [existingLogsMap, setExistingLogsMap] = useState({});
  const [expandedDays, setExpandedDays] = useState({});

  const [activeTimeBucket, setActiveTimeBucket] = useState('today'); //  01 Jul 2025 - 'today' | 'week' | 'month' | 'quarter' | 'year'
 
  // 02 Jan 2026 - Step 4: Active Year (used in By Year mode)
  const [activeYear, setActiveYear] = useState(moment().year());

  // const [percentLoggedNotToday, setPercentLoggedNotToday] = useState(0); // 02 Jul 2025 // 03 Jan 2026 - Commented

  // 06 Dec 2025 - View Tabs: 'log' | 'chart'
  const [activeViewTab, setActiveViewTab] = useState('log');

  const [tooltip, setTooltip] = useState({ visible: false });

  // 24 Feb 2026 - Toggle for showing guidance per habit
  const [expandedGuidance, setExpandedGuidance] = React.useState({});

  
  // 2a - Get Backend Data
  const { habits = [] } = useGetHabitsQuery("Habit", {
    selectFromResult: ({ data }) => ({
      habits: data?.ids?.map(id => data?.entities[id])
    }),
  });

  const habitsMorning = habits?.filter(habit => habit?.habitTimeSegments?.includes("Morning"))

  // console.log('habits', habits)
  // console.log('habitsMorning', habitsMorning)

  // 07 Dec 2025
  const [visibleHabits, setVisibleHabits] = useState(() =>
    habitsMorning.map(h => h._id)
  );


  // 2b1 - Fetch existing user habit logs - 29 Jun 2025
  const { data: userHabitLogsData = [] } = useGetUserHabitLogsQuery()
  const [createNewUserHabitLog] = useCreateNewUserHabitLogMutation()

  const [sendLogout, {}] = useSendLogoutMutation() // 23 Feb 2026

  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const userHabitLogs = extractEntitiesFromAdapter(userHabitLogsData)
  // console.log('userHabitLogs', userHabitLogs)

  // --------------------------------------------------------
  // 02 Jan 2026 - Derive available years - for By Year Chip
  // --------------------------------------------------------
  const currentYear = moment().year();

  const availableYears = React.useMemo(() => {
    if (!userHabitLogs || userHabitLogs.length === 0) {
      return [currentYear];
    }

    const yearSet = new Set();

    userHabitLogs.forEach(log => {
      if (!log?.performedAt) return;
      yearSet.add(moment(log.performedAt).year());
    });

    // Always include current year (even if empty so far)
    yearSet.add(currentYear);

    return Array.from(yearSet).sort((a, b) => b - a);
  }, [userHabitLogs, currentYear]);

  // console.log('availableYears', availableYears);

  // --------------------------------------------------
  // 02 Jan 2026 - Default year selection logic
  // --------------------------------------------------
  useEffect(() => {
    if (activeTimeBucket !== 'byYear') return;

    // Only auto-select if activeYear is not valid
    if (!availableYears.includes(activeYear)) {
      setActiveYear(availableYears[0]);
    }

    // Pick most recent available year (usually current year)
    // if (availableYears && availableYears.length > 0) {
    //   setActiveYear(availableYears[0]);
    // }
  }, [activeTimeBucket, availableYears]);


  // 2b2 - Time filters
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  // 01 Jul 2015
  const startOfWeek = moment().isoWeekday(1).startOf("day"); // Monday of current week
  const endOfWeek = endOfToday; // ✅ Cap at today

  const actualEndOfWeek = moment().isoWeekday(7).endOf("day"); // 02 Jan 2026 Sunday of current week


  const startOfMonth = moment().startOf("month"); // 1st of month
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  // 02 Jan 2026
  // Semantic (true) quarter end — for display
  const endOfQuarterActual = moment().endOf("quarter");

  // Effective quarter end — for data/chart clipping
  const endOfQuarterEffective = moment().isSame(now, 'quarter')
    ? endOfToday
    : endOfQuarterActual;

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");


  // --------------------------------------------------
  // 02 Jan 2026 - Step A - Expected calendar days for aggregates
  // --------------------------------------------------
  const expectedDates = React.useMemo(() => {
    if (activeTimeBucket === 'today') {
      return [now.format('YYYY-MM-DD')];
    }

    let start;
    let end;

    switch (activeTimeBucket) {
      case 'week':
        start = startOfWeek;
        end = endOfWeek;
        break;

      case 'month':
        start = startOfMonth;
        end = endOfMonth;
        break;

      case 'quarter':
        start = startOfQuarter;
        end = endOfQuarterEffective; // clipped
        break;

      case 'year':
        start = startOfYear;
        end = endOfYear;
        break;

      case 'byYear':
        start = moment().year(activeYear).startOf('year');
        end =
          activeYear === now.year()
            ? endOfToday
            : moment().year(activeYear).endOf('year');
        break;

      case 'all': {
        const minDate = userHabitLogs?.length
          ? moment.min(userHabitLogs.map(l => moment(l.performedAt))).startOf('day')
          : now.startOf('day');
        start = minDate;
        end = endOfToday;
        break;
      }

      default:
        return [];
    }

    const dates = [];
    let cursor = start.clone();

    while (cursor.isSameOrBefore(end, 'day')) {
      dates.push(cursor.format('YYYY-MM-DD'));
      cursor.add(1, 'day');
    }

    return dates;
  }, [
    activeTimeBucket,
    activeYear,
    now,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarterEffective,
    startOfYear,
    endOfYear,
    userHabitLogs,
  ]);

  
  // --------------------------------------------------
  // 02 Jan 2026 - Time bucket descriptive label (formatted)
  // --------------------------------------------------
  const timeBucketDescription = React.useMemo(() => {
    switch (activeTimeBucket) {
      case 'today':
        return (
          <>
            Today is <span className="font-semibold">{now.format('DD MMM YYYY')}</span>
          </>
        );

      case 'week':
        return (
          <>
            This week — Mon (
            <span className="font-semibold">
              {startOfWeek.format('DD MMM YYYY')}
            </span>
            ) - Sun (
            <span className="font-semibold">
              {actualEndOfWeek.format('DD MMM YYYY')}
            </span>
            )
          </>
        );

      case 'month':
        return (
          <>
            This month is{" "}
            <span className="font-semibold">
              {startOfMonth.format('MMMM YYYY')}
            </span>
          </>
        );

      case 'quarter': {
        const quarter = now.quarter();
        return (
          <>
            This quarter is{" "}
            <span className="font-semibold text-orange-600">
              Q{quarter} of {now.year()}
            </span>
            . Starting:{" "}
            <span className="font-semibold">
              {startOfQuarter.format('DD MMM YYYY')}
            </span>
            , Ending:{" "}
            <span className="font-semibold">
              {endOfQuarterActual.format('DD MMM YYYY')}
            </span>
          </>
        );
      }

      case 'year':
        return (
          <>
            This year is{" "}
            <span className="font-semibold">
              {now.year()}
            </span>
          </>
        );

      case 'all':
        return (
          <>
            <span className="font-semibold">All</span> the logged data
          </>
        );

      case 'byYear':
        return (
          <>
            Showing data for year{" "}
            <span className="font-semibold">
              {activeYear}
            </span>
          </>
        );

      default:
        return null;
    }
  }, [
    activeTimeBucket,
    activeYear,
    now,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    startOfQuarter,
    endOfQuarter,
  ]);


  // 2b3 - ✅ Filter logs for today only
  const userHabitLogsToday = userHabitLogs?.filter(log => {
    const logDate = moment(log?.performedAt)
    return logDate.isBetween(startOfToday, endOfToday, null, '[]')
  })

  // 2b4 - ✅ Filter logs for this week - ending today - 01 Jul 2025
  const userHabitLogsThisWeek = userHabitLogs.filter(log => {
  const logDate = moment(log.performedAt)
  return logDate.isBetween(startOfWeek, endOfWeek, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this month - ending today - 01 Jul 2025 
  const userHabitLogsThisMonth = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfMonth, endOfMonth, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this quarter - ending today - 01 Jul 2025
  const userHabitLogsThisQuarter = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfQuarter, endOfQuarter, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this year - ending today - 01 Jul 2025
  const userHabitLogsThisYear = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfYear, endOfYear, null, '[]')
  })

  // console.log('userHabitLogsToday', userHabitLogsToday)
  // console.log('userHabitLogsThisWeek', userHabitLogsThisWeek)
  // console.log('userHabitLogsThisMonth', userHabitLogsThisMonth)
  // console.log('userHabitLogsThisQuarter', userHabitLogsThisQuarter)
  // console.log('userHabitLogsThisYear', userHabitLogsThisYear)
  

  // 2c1 - Determine logs based on active tab - 01 Jul 2025
  let displayedLogs = [];

  switch (activeTimeBucket) {
    case 'week':
      displayedLogs = userHabitLogsThisWeek;
      break;
    case 'month':
      displayedLogs = userHabitLogsThisMonth;
      break;
    case 'quarter':
      displayedLogs = userHabitLogsThisQuarter;
      break;
    case 'year':
      displayedLogs = userHabitLogsThisYear;
      break;
    // 02 Jan 2026
    case 'all':
      displayedLogs = userHabitLogs;
      break;

    // --------------------------------------------------
    // 02 Jan 2026 - By Year filtering
    // --------------------------------------------------
    case 'byYear':
      displayedLogs = userHabitLogs.filter(log => {
        if (!log?.performedAt) return false;

        const logMoment = moment(log.performedAt);
        const logYear = logMoment.year();

        // Must match selected year
        if (logYear !== activeYear) return false;

        // If current year, cap at today
        if (logYear === moment().year()) {
          return logMoment.isSameOrBefore(moment(), 'day');
        }

        return true;
      });
      break;

    case 'today':
    default:
      displayedLogs = userHabitLogsToday;
      break;
  }

  // --------------------------------------------------
  // 02 Jan 2026 - Step B -  Expected day → habit matrix
  // --------------------------------------------------
  const expectedDayHabitMap = React.useMemo(() => {
    const map = {};

    // 1️⃣ Initialize all expected days with all habits = not logged
    expectedDates.forEach(dateKey => {
      map[dateKey] = {};

      habitsMorning.forEach(habit => {
        map[dateKey][habit._id] = {
          performed: false,
          log: null,
        };
      });
    });

    // 2️⃣ Overlay actual logs
    displayedLogs.forEach(log => {
      if (!log?.performedAt || !log?.habitId?._id) return;

      const dateKey = moment(log.performedAt).format('YYYY-MM-DD');
      const habitId = log.habitId._id;

      if (!map[dateKey] || !map[dateKey][habitId]) return;

      map[dateKey][habitId] = {
        performed: !!log.performed,
        log,
      };
    });

    return map;
  }, [expectedDates, habitsMorning, displayedLogs]);


  // 2c2 - Build lookup map for today only (used for performed check + disabling fields)
  const userHabitLogTodayMap = {};
  userHabitLogsToday.forEach(log => {
    const habitId = log?.habitId?._id;
    if (habitId) {
      userHabitLogTodayMap[habitId] = log;
    }
  });

  // 2c3 - Calculate percentage of morning habits logged - 02 Jul 2025
  const totalMorningHabits = habitsMorning?.length || 0;
  const habitsLoggedToday = habitsMorning.filter(habit => !!userHabitLogTodayMap[habit._id]).length;
  const percentLogged = totalMorningHabits > 0 
    ? Math.round((habitsLoggedToday / totalMorningHabits) * 100)
    : 0;

  // 2c4 - Calculate percentage of mornig habits logged not for today - 02 Jul 2025

  //03 Jan 2026 - Fix for infinite rerenders 

    const percentLoggedNotToday = React.useMemo(() => {
    if (activeTimeBucket === 'today') return 0;

    let totalHabitsAcrossDays = 0;
    let totalLoggedAcrossDays = 0;

    Object.values(expectedDayHabitMap).forEach(dayHabits => {
      habitsMorning.forEach(habit => {
        totalHabitsAcrossDays++;

        if (dayHabits?.[habit._id]?.performed) {
          totalLoggedAcrossDays++;
        }
      });
    });

    return totalHabitsAcrossDays > 0
      ? Math.round((totalLoggedAcrossDays / totalHabitsAcrossDays) * 100)
      : 0;
  }, [activeTimeBucket, expectedDayHabitMap, habitsMorning]);

  // 2d - default time
  
  const defaultTime = moment().startOf('minute').format('h:mm A');


  // 2e1 - Plexus Icons Map
  const plexusIconMap = {
    Physical: EtEnergyPhysicalIcon1SVGComp,
    Mental: EtEnergyMentalIcon1SVGComp,
    Emotional: EtEnergyEmotionalIcon1SVGComp,
    Intellectual: EtEnergyIntellectualIcon1SVGComp,
    Spiritual: EtEnergySpiritualIcon1SVGComp,
  };

  // 2e2 - Plexus ColorMap
  const plexusColorMap = {
    Physical: "bg-orange-100 text-orange-800",
    Mental: "bg-yellow-200 text-yellow-800",
    Emotional: "bg-lime-400 text-lime-900",
    Intellectual: "bg-red-300 text-red-900",
    Spiritual: "bg-purple-300 text-purple-900",
  };

  // 3 - Handle Performance Change - 27 Jun 2025
  const handlePerformanceChange = (habitId, value) => {
    setPerformanceByHabitId(prev => ({
      ...prev,
      [habitId]: value
    }));
  };

  // 4 - Submit User Habit Log
  const handleLogIt = async (habit) => {
    const habitId = habit._id;

    // const performed = performedToggle[habitId] || false;
    const performed = true
    const note = experienceNotes[habitId] || '';

    // const selectedTime = timePicker[habitId] || defaultTime;
    // const performedAt = moment(selectedTime, 'h:mm A').toDate();
    // 02 Jul 2025
    const selectedTimeStr = timePicker[habitId];

    const performedAt = selectedTimeStr
    ? moment(selectedTimeStr, 'h:mm A').toDate()
    : moment().toDate(); // fallback to "Now" if nothing selected


    try {
      const payload = {
        habitId,
        habitTimeSegments: ['Morning'], // ✅ even if defaulted, keep it explicit
        performed,
        performedAt,
        durationMin: 0,                 // ⬜ future: allow duration entry
        experienceRating: 0,           // ⬜ future: star/emoji input
        experienceNotes: note ? [{ experienceNoteText: note }] : [],
        pic: '',                        // ⬜ placeholder (future: selfie?)
        aboutMe: '',                    // ⬜ placeholder (future: reflection?)
      };

      const response = await createNewUserHabitLog(payload).unwrap();

      // Add to today’s log map on success
      setExistingLogsMap(prev => ({
        ...prev,
        [habitId]: response,
      }));

    } catch (error) {
      console.error('❌ Error creating habit log:', error);
    }
  };

  // 5 - Transform displayed logs into chart-ready dataset - 06 Dec 2025
  const { chartData, bucketDates } = React.useMemo(() => {
    if (!displayedLogs || displayedLogs.length === 0) {
      return { chartData: [], bucketDates: [] };
    }

    // Determine ordered date list based on active time bucket
    const bucketDates = [];

    let start, end;

    if (activeTimeBucket === 'today') {
      start = moment().startOf('day');
      end = moment().endOf('day');
    } else if (activeTimeBucket === 'week') {
      start = startOfWeek;
      end = endOfWeek;
    } else if (activeTimeBucket === 'month') {
      start = startOfMonth;
      end = endOfMonth;
    } else if (activeTimeBucket === 'quarter') {
      start = startOfQuarter;
      end = endOfQuarter;
    // } else {
    } else if (activeTimeBucket === 'year') {
      start = startOfYear;
      end = endOfYear;
    } else {
      // 02 Jan 2026 - NEW: 'all' (fallback)
      const minDate = displayedLogs?.length
        ? moment.min(displayedLogs.map(l => moment(l.performedAt))).startOf('day')
        : moment().startOf('year');

      start = minDate;
      end = moment().endOf('day'); // cap at today
    }
   

    // Build list of days for the period
    let dayCursor = start.clone();
    let dayCount = 0;
    const maxDays = 365; // Safety limit

    while (dayCursor.isSameOrBefore(end, 'day') && dayCount < maxDays) {
      bucketDates.push(dayCursor.format('YYYY-MM-DD'));
      dayCursor.add(1, 'day');
      dayCount++;
    }

    // Map dates to index
    const dateToIndexMap = {};
    bucketDates.forEach((d, idx) => {
      dateToIndexMap[d] = idx;
    });

    // 23 Feb 2026
    // ✅ Transform logs (downsample for quarter/year)
    const stepDays =
      activeTimeBucket === 'month' ? 2 :
      activeTimeBucket === 'quarter' ? 7 :
      activeTimeBucket === 'year' ? 14 :
      activeTimeBucket === 'all' ? 14 :
      null;

    // 1) Sort logs by performedAt so "latest in slice wins"
    const sortedLogs = [...displayedLogs].sort((a, b) =>
      moment(a.performedAt).diff(moment(b.performedAt))
    );

    // 2) Downsample if needed: keep 1 log per habit per slice
    let logsToChart = sortedLogs;

    if (stepDays) {
      const sliceMap = new Map(); // key: `${habitId}-${sliceIndex}` -> log

      sortedLogs.forEach((log) => {
        const performedAt = moment(log?.performedAt);
        const dateKey = performedAt.format('YYYY-MM-DD');
        const dayIndex = dateToIndexMap[dateKey];

        if (dayIndex === undefined) return;

        const habitId = log?.habitId?._id;
        if (!habitId) return;

        const sliceIndex = Math.floor(dayIndex / stepDays);
        const key = `${habitId}-${sliceIndex}`;

        // Overwrite => latest within slice (because sorted ascending)
        sliceMap.set(key, log);
      });

      logsToChart = Array.from(sliceMap.values()).sort((a, b) =>
        moment(a.performedAt).diff(moment(b.performedAt))
      );
    }


    // Transform logs
    // const chartData = displayedLogs.map(log => {
    //   const performedAt = moment(log.performedAt);
    //   const dateKey = performedAt.format('YYYY-MM-DD');
    //   const dayIndex = dateToIndexMap[dateKey] ?? 0;

    //   const epochMinutes =
    //     performedAt.hours() * 60 + performedAt.minutes();

    //   const habit = log?.habitId || {};
    //   const habitId = habit._id;
    //   const habitName = habit.habitName || "";
    //   const plexus = habit.habitPlexus || "";

    //   const color = plexusColorMap[plexus]
    //     ? plexusColorMap[plexus].split(" ")[0].replace("bg-", "").replace("-100", "")
    //     : "gray";

    //   const note = log?.experienceNotes?.at(-1)?.experienceNoteText || "";

    //   return {
    //     habitId,
    //     habitName,
    //     plexus,
    //     dateKey,
    //     dayIndex,
    //     xValue: dayIndex,                                   // NEW
    //     xLabel: moment(dateKey).format("DD MMM"),           // NEW
    //     epochMinutes,
    //     performedAt: performedAt.toDate(),
    //     note,
    //     color,
    //   }; 
    // });

    // 3) Map logsToChart to chartData (your existing transform)
    const chartData = logsToChart.map(log => {
      const performedAt = moment(log.performedAt);
      const dateKey = performedAt.format('YYYY-MM-DD');
      const dayIndex = dateToIndexMap[dateKey] ?? 0;

      const epochMinutes =
        performedAt.hours() * 60 + performedAt.minutes();

      const habit = log?.habitId || {};
      const habitId = habit._id;
      const habitName = habit.habitName || "";
      const plexus = habit.habitPlexus || "";

      const color = plexusColorMap[plexus]
        ? plexusColorMap[plexus].split(" ")[0].replace("bg-", "").replace("-100", "")
        : "gray";

      const note = log?.experienceNotes?.at(-1)?.experienceNoteText || "";

      return {
        habitId,
        habitName,
        plexus,
        dateKey,
        dayIndex,
        xValue: dayIndex,
        xLabel: moment(dateKey).format("DD MMM"),
        epochMinutes,
        performedAt: performedAt.toDate(),
        note,
        color,
      }; 
    });

    chartData.sort((a, b) => a.xValue - b.xValue);

    return { chartData, bucketDates };
  }, [
    displayedLogs,
    activeTimeBucket,
  ]);

  // 5a — Per-habit series model (Option 1, unified domain with null gaps)
  const { habitSeries, allDatePoints } = React.useMemo(() => {
    if (!chartData || chartData.length === 0) {
      return { habitSeries: [], allDatePoints: [] };
    }

    // 1 — Sort by date
    const sorted = [...chartData].sort((a, b) =>
      moment(a.dateKey).diff(moment(b.dateKey))
    );

    // 2 — Build unique ordered x-axis points (master domain)
    const allDatePoints = [];
    const seen = new Set();
    sorted.forEach((d) => {
      if (!seen.has(d.xValue)) {
        seen.add(d.xValue);
        allDatePoints.push({
          xValue: d.xValue,
          xLabel: d.xLabel,
        });
      }
    });

    // 3 — Stable color palette (no random / no flicker)
    const colorPalette = ["#EA580C", "#2563EB", "#16A34A", "#DB2777", "#7C3AED"];

    // 4 — Initialize per-habit series with full domain, epochMinutes = null
    const habitSeriesMap = {};
    habitsMorning.forEach((habit, index) => {
      habitSeriesMap[habit._id] = {
        habitId: habit._id,
        habitName: habit.habitName,
        color: colorPalette[index % colorPalette.length],
        points: allDatePoints.map((pt) => ({
          xValue: pt.xValue,
          epochMinutes: null,
        })),
      };
    });

    // 5 — Fill actual values for days that have logs
    //     (leaving other days as null so connectNulls can span them)
    sorted.forEach((d) => {
      const series = habitSeriesMap[d.habitId];
      if (!series) return;

      // find the index for this xValue in the full domain
      const idx = allDatePoints.findIndex((pt) => pt.xValue === d.xValue);
      if (idx === -1) return;

      series.points[idx].epochMinutes = d.epochMinutes;
    });

    return {
      habitSeries: Object.values(habitSeriesMap),
      allDatePoints,
    };
  }, [chartData, habitsMorning]);

  // console.log('allDatePoints', allDatePoints)
  // console.log('habitSeries', habitSeries)

  // 6 - Recharts requires flat hex colors - 06 Dec 2025
  const plexusColorHexMap = {
    Physical: "#EA580C",     // orange
    Mental: "#2563EB",       // blue
    Emotional: "#16A34A",    // green
    Intellectual: "#DB2777", // pink
    Spiritual: "#7C3AED",    // purple
  };

  // 7 - TickInterval
  const tickInterval = (() => {
    if (activeTimeBucket === "today") return 0;
    if (activeTimeBucket === "week") return 0;
    if (activeTimeBucket === "month") return 3;
    if (activeTimeBucket === "quarter") return 7;
    if (activeTimeBucket === "year") return 30;
  })();

  // ✅ 7b - Mobile-friendly X ticks: weekly for quarter, biweekly for year/all - 20 Feb 2026
  const xTickStep =
  activeTimeBucket === 'month' ? 3 :                 // ✅ every ~3 days
  activeTimeBucket === 'quarter' ? 7 :               // ✅ weekly
  (activeTimeBucket === 'year' || activeTimeBucket === 'all') ? 14 :  // ✅ biweekly
  1;

  const xTicks = React.useMemo(() => {
    if (!allDatePoints?.length) return [];

    // Keep the first and last tick so the axis never looks empty
    const ticks = allDatePoints
      .filter(pt => pt.xValue % xTickStep === 0)
      .map(pt => pt.xValue);

    const first = allDatePoints[0]?.xValue;
    const last = allDatePoints[allDatePoints.length - 1]?.xValue;

    if (first !== undefined && !ticks.includes(first)) ticks.unshift(first);
    if (last !== undefined && !ticks.includes(last)) ticks.push(last);

    // De-dupe (in case first/last already present)
    return Array.from(new Set(ticks)).sort((a, b) => a - b);
  }, [allDatePoints, xTickStep]);



  // 8 - Create an object for setting inner HTML
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  // 9 - Handle Logout
  const handleLogout = async () => {
    try {
      await sendLogout().unwrap();
      navigate('/login')
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
  // <div className="max-w-md mx-auto font-poppins">
  <div className="flex flex-col h-screen bg-gray-200 p-4 rounded m-1 overflow-auto max-w-md mx-auto ml-1 mr-1 font-poppins">

    {/* -------------------------------- */}
    {/* Header (mobile sticky) */}
    {/* -------------------------------- */}
    <div className="top-0 z-30 bg-white border-b mx-2 px-2 rounded-xl">
      

      {/* Logout */}
      <div className="flex justify-end cursor-pointer m-1 p-1" onClick={handleLogout}>
        <div className="flex justify-center items-center rounded-full w-6 h-6 bg-gradient-to-r from-orange-800 to-orange-800 via-orange-600 shadow-xl shadow-gray-600">
          <EtLogoutIcon1SVGComp className="h-4 w-4 text-white" />
        </div>
      </div>

      {/* Trinity Bar (tap logo to go back) */}
      <div className="flex justify-center items-center m-1 p-1">
        <div
          className="flex justify-center items-center rounded-full shadow-lg shadow-gray-600 cursor-pointer"
          onClick={() => navigate('/etapp/mobile')}
        >
          <img src={TrinityIcon} alt="" className="h-24 w-24" />
        </div>
      </div>
      
      
      <div className="flex justify-center items-center px-3 py-3">
        <h3 className="font-bold text-gray-800 py-3 text-xl">Morning Energizers</h3>

        {/* <button
          onClick={handleClose}
          className="text-sm font-semibold text-orange-700"
        >
          Close
        </button> */}
      </div>

      {/* -------------------------------- */}
      {/* Time Chips (scrollable) */}
      {/* -------------------------------- */}
      <div className="px-2 pb-2">
        <div className="flex gap-2 overflow-x-auto no-scrollbar py-2">
          {[
            { label: 'Today', value: 'today' },
            { label: 'Week', value: 'week' },
            { label: 'Month', value: 'month' },
            { label: 'Qtr', value: 'quarter' },
            { label: 'Year', value: 'year' },
            { label: 'By Year', value: 'byYear' },
            { label: 'All', value: 'all' },
          ].map(({ label, value }) => (
            <button
              key={value}
              onClick={() => setActiveTimeBucket(value)}
              className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                ${activeTimeBucket === value
                  ? 'bg-orange-600 text-white border-orange-700'
                  : 'bg-gray-100 text-gray-700 border-gray-300'
                }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Time bucket description */}
        {timeBucketDescription && (
          <div className="mt-2 mx-1 px-3 py-2 bg-orange-50 border border-orange-200 rounded">
            <p className="text-xs text-gray-700">
              {timeBucketDescription}
            </p>
          </div>
        )}

        {/* By Year selector */}
        {activeTimeBucket === 'byYear' && (
          <div className="flex gap-2 overflow-x-auto no-scrollbar mt-2 px-1 pb-2">
            {availableYears.map((year) => (
              <button
                key={year}
                onClick={() => setActiveYear(year)}
                className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                  ${activeYear === year
                    ? 'bg-orange-600 text-white border-orange-700'
                    : 'bg-gray-100 text-gray-700 border-gray-300'
                  }`}
              >
                {year}
              </button>
            ))}
          </div>
        )}

        {/* -------------------------------- */}
        {/* View Tabs (segmented) */}
        {/* -------------------------------- */}
        <div className="mt-2 mx-1 grid grid-cols-2 bg-gray-100 rounded-lg p-1">
          <button
            onClick={() => setActiveViewTab('log')}
            className={`text-sm font-semibold py-2 rounded-md
              ${activeViewTab === 'log'
                ? 'bg-white text-orange-700 shadow-sm'
                : 'text-gray-500'
              }`}
          >
            Log
          </button>

          <button
            onClick={() => setActiveViewTab('chart')}
            className={`text-sm font-semibold py-2 rounded-md
              ${activeViewTab === 'chart'
                ? 'bg-white text-orange-700 shadow-sm'
                : 'text-gray-500'
              }`}
          >
            Chart
          </button>
        </div>
      </div>
    </div>

    {/* -------------------------------- */}
    {/* Body */}
    {/* -------------------------------- */}
    <div className="px-2 py-2">

      {/* Empty state */}
      {activeViewTab === 'log' && habits?.length === 0 && (
        <p className="text-sm text-gray-500">No morning habits configured yet.</p>
      )}

      {/* -------------------------------- */}
      {/* LOG VIEW */}
      {/* -------------------------------- */}
      {activeViewTab === 'log' && (
        <>
          {/* Stats Card */}
          {habits?.length > 0 && (
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-3 mb-4">
              {activeTimeBucket === 'today' ? (
                percentLogged === 100 ? (
                  <p className="text-sm text-gray-700">
                    You’ve completed <span className="font-bold text-orange-700">100%</span> of your morning energizers{" "}
                    <span className="font-bold">today</span>.
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    You’ve completed <span className="font-bold text-orange-700">{percentLogged}%</span> of your morning energizers today.
                  </p>
                )
              ) : (
                <p className="text-sm text-gray-700">
                  You’ve completed <span className="font-bold text-orange-700">{percentLoggedNotToday}%</span> of your morning energizers{" "}
                  {activeTimeBucket === 'byYear' ? (
                    <>in <span className="font-bold">{activeYear}</span>.</>
                  ) : (
                    <>this <span className="font-bold capitalize">{activeTimeBucket}</span>.</>
                  )}
                </p>
              )}
            </div>
          )}

          {/* -------------------------------- */}
          {/* TODAY: Habit cards */}
          {/* -------------------------------- */}
          {habits?.length > 0 && activeTimeBucket === 'today' && (
            <div className="space-y-3">
              {habitsMorning?.map((habit, habitIndex) => {
                const IconComp = plexusIconMap[habit.habitPlexus] || EtHabitsSortIcon1SVGComp;
                const plexus = habit?.habitPlexus || "";
                const name = habit?.habitName || "";
                const desc = habit?.habitDesc || "";
                const pic = habit?.pic || "";
                const instructions = habit?.timeBasedInstructions?.[0]?.morning || [];
                const MyHabitIcon = createSvgComponentFromBase64(pic);

                const isLogged = !!userHabitLogTodayMap[habit._id];

                return (
                  <div
                    key={habit._id}
                    className="bg-white border rounded-xl shadow-sm p-3"
                  >
                    {/* Header row */}
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex items-start gap-3">
                        {/* Checkbox */}
                        <div className="pt-1">
                          <input
                            type="checkbox"
                            checked={isLogged}
                            onChange={() => {
                              setSelectedHabitIds(prev =>
                                prev.includes(habit._id)
                                  ? prev.filter(id => id !== habit._id)
                                  : [...prev, habit._id]
                              );
                            }}
                            className={`
                              cursor-default appearance-none
                              w-5 h-5 rounded border-2 relative
                              ${isLogged
                                ? `bg-lime-500 border-lime-500
                                  before:content-['✔'] before:absolute before:text-white
                                  before:text-xs before:top-[1px] before:left-[3px] before:font-bold`
                                : `bg-white border-gray-400`
                              }
                            `}
                          />
                        </div>

                        {/* Icons */}
                        <div className="flex items-center gap-2">
                          <div className="flex justify-center items-center w-9 h-9 rounded-full bg-gradient-to-r from-orange-600 via-orange-800 to-black shadow">
                            <IconComp className="h-7 w-7 text-white" />
                          </div>

                          <div className="h-9 w-9 rounded-full bg-white border flex items-center justify-center">
                            <MyHabitIcon className="h-7 w-7 text-orange-600" />
                          </div>
                        </div>

                        {/* Title */}
                        <div>
                          <p className="text-sm font-bold text-gray-800">{name}</p>
                          <p className={`inline-block mt-1 text-[11px] font-bold px-2 py-[2px] rounded-full ${plexusColorMap[habit.habitPlexus] || "bg-gray-100 text-gray-800"}`}>
                            {plexus}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Guidance */}

                    {/* Guidance */}
                    <div 
                      className="mt-3"
                      onClick={() =>
                          setExpandedGuidance(prev => ({
                            ...prev,
                            [habit._id]: !prev[habit._id],
                          }))
                      }  
                    >
                      <div className="flex justify-start items-center">
                        {expandedGuidance[habit._id] ? (
                          <MinusIcon className="h-4 w-4 text-orange-600" />
                        ) : (
                          <PlusIcon className="h-4 w-4 text-orange-600" />
                        )}
                        <p className="text-xs font-bold text-gray-700 mx-1 px-1">
                          Action Guidance
                        </p>
                      </div>

                      {/* Collapsible Content */}
                      {expandedGuidance[habit._id] && (
                        <div className="mt-2">
                          {instructions?.length === 0 ? (
                            <div
                              className="text-xs text-gray-600 leading-5"
                              dangerouslySetInnerHTML={createMarkup(desc)}
                            />
                          ) : (
                            <div className="space-y-2">
                              {instructions.map((ins, insIndex) => {
                                const guidance = ins?.instruction || "";
                                return (
                                  <div
                                    key={`${habit._id}-ins-${insIndex}`}
                                    className="bg-orange-50 border border-orange-100 rounded-lg px-2 py-2"
                                  >
                                    <p className="text-xs text-gray-700">{guidance}</p>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {/* <div className="mt-3">
                      <p className="text-xs font-bold text-gray-700 mb-1">Action Guidance</p>

                      {instructions?.length === 0 ? (
                        <div className="text-xs text-gray-600 leading-5" dangerouslySetInnerHTML={createMarkup(desc)} />
                      ) : (
                        <div className="space-y-2">
                          {instructions.map((ins, insIndex) => {
                            const guidance = ins?.instruction || "";
                            return (
                              <div key={`${habit._id}-ins-${insIndex}`} className="bg-orange-50 border border-orange-100 rounded-lg px-2 py-2">
                                <p className="text-xs text-gray-700">{guidance}</p>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div> */}

                    {/* Performance (full width) */}
                    <div className="mt-3">
                      <EtHabitPerformanceDetailMobile
                        habit={habit}
                        userHabitLogTodayMap={userHabitLogTodayMap}
                        performedToggle={performedToggle}
                        timePicker={timePicker}
                        experienceNotes={experienceNotes}
                        defaultTime={defaultTime}
                        setPerformedToggle={setPerformedToggle}
                        setTimePicker={setTimePicker}
                        setExperienceNotes={setExperienceNotes}
                        handleLogIt={handleLogIt}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* -------------------------------- */}
          {/* NOT TODAY: Day accordion cards */}
          {/* -------------------------------- */}
          {habits?.length > 0 && activeTimeBucket !== 'today' && (
            <div className="space-y-3">

              {(() => {
                // group logs by day
                const logsByDay = {};

                displayedLogs.forEach(log => {
                  const dayKey = moment(log.performedAt).format('YYYY-MM-DD');
                  if (!logsByDay[dayKey]) logsByDay[dayKey] = {};
                  logsByDay[dayKey][log.habitId._id] = log;
                });

                return Object.entries(logsByDay)
                  .sort(([dateA], [dateB]) => moment(dateB).diff(moment(dateA)))
                  .map(([date, logs], idx) => {
                    const formattedDate = moment(date).format('ddd, DD MMM YYYY');
                    const isExpanded = expandedDays[date];

                    // quick summary: how many habits logged that day
                    const dayLoggedCount = habitsMorning.reduce((acc, h) => {
                      const l = logs?.[h._id];
                      return acc + (l?.performed ? 1 : 0);
                    }, 0);

                    return (
                      <div key={date} className="bg-white border rounded-xl shadow-sm overflow-hidden">

                        {/* Day header */}
                        <button
                          type="button"
                          onClick={() => setExpandedDays(prev => ({ ...prev, [date]: !prev[date] }))}
                          className="w-full flex items-center justify-between px-3 py-3 bg-gray-50"
                        >
                          <div className="flex items-center gap-2">
                            {isExpanded ? (
                              <MinusIcon className="h-5 w-5 text-orange-600" />
                            ) : (
                              <PlusIcon className="h-5 w-5 text-orange-600" />
                            )}

                            <p className="text-sm font-bold text-gray-700">
                              {idx + 1}. <span className="text-orange-700">{formattedDate}</span>
                            </p>
                          </div>

                          <p className="text-xs font-bold text-gray-600">
                            {dayLoggedCount}/{habitsMorning.length} logged
                          </p>
                        </button>

                        {/* Compact row: habit icons + status */}
                        <div className="px-3 py-3">
                          <div className="grid grid-cols-2 gap-2">
                            {habitsMorning.map((habit) => {
                              const habitId = habit._id;
                              const log = logs?.[habitId] || null;
                              const isLogged = log?.performed || false;

                              const MyHabitIcon = createSvgComponentFromBase64(habit?.pic || "");
                              const name = habit?.habitName || "";

                              return (
                                <div key={habitId} className="flex items-center gap-2 border rounded-lg p-2">
                                  <input
                                    type="checkbox"
                                    checked={isLogged}
                                    readOnly
                                    className={`
                                      appearance-none w-4 h-4 rounded border-2 relative
                                      ${isLogged
                                        ? `bg-lime-500 border-lime-500
                                          before:content-['✔'] before:absolute before:text-white
                                          before:text-[10px] before:top-[-1px] before:left-[2px] before:font-bold`
                                        : `bg-white border-gray-300`
                                      }
                                    `}
                                  />

                                  <div className="h-8 w-8 rounded-full bg-white border flex items-center justify-center">
                                    <MyHabitIcon className="h-6 w-6 text-orange-600" />
                                  </div>

                                  <div className="min-w-0">
                                    <p className="text-xs font-bold text-gray-700 truncate">{name}</p>
                                    <p className="text-[11px] text-gray-500">
                                      {isLogged ? (
                                        new Date(log?.performedAt).toLocaleString('en-US', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: true,
                                        })
                                      ) : (
                                        'Not yet'
                                      )}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Expanded detail */}
                        {isExpanded && (
                          <div className="px-3 pb-3">
                            <div className="bg-orange-50 border border-orange-200 rounded-xl p-3 space-y-3">
                              {habitsMorning.map(habit => {
                                const habitId = habit._id;
                                const log = logs?.[habitId] || null;

                                const IconComp = plexusIconMap[habit.habitPlexus] || EtHabitsSortIcon1SVGComp;
                                const plexus = habit?.habitPlexus || "";
                                const name = habit?.habitName || "";
                                const desc = habit?.habitDesc || "";
                                const instructions = habit?.timeBasedInstructions?.[0]?.morning || [];
                                const MyHabitIcon = createSvgComponentFromBase64(habit?.pic || "");

                                return (
                                  <div key={habitId} className="bg-white border rounded-xl p-3">
                                    {/* mini header */}
                                    <div className="flex items-start justify-between gap-3">
                                      <div className="flex items-start gap-3">
                                        <input
                                          type="checkbox"
                                          checked={!!log?.performed}
                                          readOnly
                                          className={`
                                            appearance-none w-5 h-5 rounded border-2 relative mt-1
                                            ${log?.performed
                                              ? `bg-lime-500 border-lime-500
                                                before:content-['✔'] before:absolute before:text-white
                                                before:text-xs before:top-[1px] before:left-[3px] before:font-bold`
                                              : `bg-white border-gray-300`
                                            }
                                          `}
                                        />

                                        <div className="flex items-center gap-2">
                                          <div className="flex justify-center items-center w-9 h-9 rounded-full bg-gradient-to-r from-orange-600 via-orange-800 to-black shadow">
                                            <IconComp className="h-7 w-7 text-white" />
                                          </div>

                                          <div className="h-9 w-9 rounded-full bg-white border flex items-center justify-center">
                                            <MyHabitIcon className="h-7 w-7 text-orange-600" />
                                          </div>
                                        </div>

                                        <div>
                                          <p className="text-sm font-bold text-gray-800">{name}</p>
                                          <p className={`inline-block mt-1 text-[11px] font-bold px-2 py-[2px] rounded-full ${plexusColorMap[habit.habitPlexus] || "bg-gray-100 text-gray-800"}`}>
                                            {plexus}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {/* guidance */}
                                    <div className="mt-3">
                                      <p className="text-xs font-bold text-gray-700 mb-1">Action Guidance</p>
                                      {instructions?.length === 0 ? (
                                        <div className="text-xs text-gray-600 leading-5" dangerouslySetInnerHTML={createMarkup(desc)} />
                                      ) : (
                                        <div className="space-y-2">
                                          {instructions.map((ins, insIndex) => {
                                            const guidance = ins?.instruction || "";
                                            return (
                                              <div key={`${habitId}-ins-${insIndex}`} className="bg-orange-50 border border-orange-100 rounded-lg px-2 py-2">
                                                <p className="text-xs text-gray-700">{guidance}</p>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>

                                    {/* performance read-only if log exists */}
                                    <div className="mt-3">
                                      {log ? (
                                        <EtHabitPerformanceDetailMobile
                                          habit={habit}
                                          userHabitLogTodayMap={{ [habitId]: log }}
                                          performedToggle={{}}
                                          timePicker={{}}
                                          experienceNotes={{}}
                                          defaultTime=""
                                          setPerformedToggle={() => {}}
                                          setTimePicker={() => {}}
                                          setExperienceNotes={() => {}}
                                          handleLogIt={() => {}}
                                        />
                                      ) : (
                                        <p className="text-xs text-gray-500">No log captured for this habit on this day.</p>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  });
              })()}

            </div>
          )}
        </>
      )}

      {/* -------------------------------- */}
      {/* CHART VIEW (mobile friendly) */}
      {/* -------------------------------- */}
      {activeViewTab === 'chart' && (
        <div className="bg-white border rounded-xl shadow-sm p-3">

          <p className="text-sm font-semibold text-gray-700 mb-2">
            Habit Activity Chart
          </p>

          {/* Habit Filter (scrollable) */}
          <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2 mb-2">
            {habitsMorning.map(h => {
              const MyHabitIcon = createSvgComponentFromBase64(h.pic);

              return (
                <label
                  key={h._id}
                  className={`flex items-center gap-2 text-xs cursor-pointer px-2 py-1 border rounded-full whitespace-nowrap
                    ${visibleHabits.includes(h._id) ? 'bg-orange-100 border-orange-300' : 'bg-gray-50 border-gray-200'}
                  `}
                >
                  <input
                    type="checkbox"
                    checked={visibleHabits.includes(h._id)}
                    onChange={() => {
                      setVisibleHabits(prev =>
                        prev.includes(h._id)
                          ? prev.filter(id => id !== h._id)
                          : [...prev, h._id]
                      );
                    }}
                  />
                  {MyHabitIcon && (
                    <MyHabitIcon className="h-4 w-4 flex-shrink-0 text-orange-600" />
                  )}
                  <span>{h.habitName}</span>
                </label>
              );
            })}
          </div>

          {/* Chart container */}
          <div className="w-full h-[320px] text-xs">
            <ResponsiveContainer>
              <ComposedChart
                data={allDatePoints}
                margin={{ top: 10, right: 15, bottom: 10, left: 10 }}
              >
                <CartesianGrid strokeDasharray="3 3" />

                <XAxis
                  dataKey="xValue"
                  type="number"
                  domain={['dataMin', 'dataMax']}
                  ticks={allDatePoints.map(d => d.xValue)}
                  tickFormatter={(x) => {
                    const item = allDatePoints.find((d) => d.xValue === x);
                    return item?.xLabel || "";
                  }}
                />

                

                <YAxis
                  type="number"
                  domain={[60, 720]}
                  ticks={[60, 180, 360, 540, 720]}
                  tickFormatter={(m) =>
                    moment().startOf("day").add(m, "minutes").format("h A")
                  }
                />

                <Tooltip
                  content={({ active, payload, label }) => {
                    if (!active || !payload || payload.length === 0) return null;

                    const dateLabel = allDatePoints.find(d => d.xValue === label)?.xLabel || label;

                    return (
                      <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
                        <p className="font-semibold text-gray-700 mb-2">{dateLabel}</p>
                        {payload.map((entry, index) => {
                          if (entry.value === undefined || entry.value === null) return null;
                          const timeFormatted = moment()
                            .startOf("day")
                            .add(entry.value, "minutes")
                            .format("h:mm A");
                          return (
                            <p key={index} className="text-sm" style={{ color: entry.color }}>
                              {entry.name}: {timeFormatted}
                            </p>
                          );
                        })}
                      </div>
                    );
                  }}
                />

                {!(activeTimeBucket === 'quarter' || activeTimeBucket === 'year' || activeTimeBucket === 'all') && (
                  <Legend wrapperStyle={{ paddingTop: 10 }} />
                )}

                {/* <Legend wrapperStyle={{ paddingTop: 10 }} 
                /> */}

                {habitSeries
                  .filter(series => visibleHabits.includes(series.habitId))
                  .slice(
                    0,
                    (activeTimeBucket === 'quarter' && 6) ||
                    ((activeTimeBucket === 'year' || activeTimeBucket === 'all') && 4) ||
                    habitSeries.length
                  )
                  .map((series) => (
                    <Line
                      key={series.habitId}
                      type="monotone"
                      data={series.points}
                      dataKey="epochMinutes"
                      stroke={series.color}
                      strokeWidth={2}
                      dot={{ r: 1, fill: series.color }}
                      name={series.habitName}
                      connectNulls={true}
                    />
                ))}
              </ComposedChart>
            </ResponsiveContainer>
          </div>

        </div>
      )}

    </div>
  </div>
);
  
};

export default EtTrinityMorningHabitsMobile;